'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopPageModal = void 0;
const $ = require("jquery");
class TopPageModal {
    constructor() {
        $('.trigOpenTopModal').on('click', (e) => {
            $('.bulletTopOverlay').fadeIn('slow').css('display', 'flex');
        });
        // ✕か背景押したらモーダル閉じる
        $('.trigCloseTopModal').on('click', (e) => {
            if (!$(e.target).closest('.paramModalContent').length) {
                $('.bulletTopOverlay').fadeOut('slow');
            }
        });
    }
}
exports.TopPageModal = TopPageModal;
exports.default = TopPageModal;
